@if (variant()) {
  <button
    [class]="'button ' + (buttonClasses() || '')"
    [disabled]="disabled()"
    (click)="handleClick($event)"
    [type]="type()"
    [ngClass]="{
      button__white: variant() === 'white',
      button__primary: variant() === 'primary',
      button__normal: variant() === 'normal',
      button__secondary: variant() === 'secondary',
      button__info: variant() === 'info',
      'button__primary--outlined': variant() === 'primary-outlined',
      'button__secondary--outlined': variant() === 'secondary-outlined',
      'button--medium': size() === 'medium',
      'button--large': size() === 'large',
      'button--disabled': disabled(),
      'flex-row-reverse': iconReversePosition(),
      uppercase: uppercase(),
      'button--white': color() === 'white',
      'button--danger': color() === 'danger',
      'button--success': color() === 'success',
      'button--info': color() === 'info',
      '!rounded-half': fullRounded(),
      'justify-center': textCenter(),
      '!w-full justify-between': wFull(),
      'is-logged-in': isUserLoggedIn,
    }">
    @if (!!icon()) {
      <span>
        <i
          class="iconsax button__icon"
          [ngClass]="iconClasses()"
          [class.button__icon--badge]="withBadge()"
          [class.button__icon--rotate-icon-in-rtl]="rotateIconInRtl()"
          [attr.icon-name]="icon()"></i>
      </span>
    }

    @if (!noContentButton()) {
      <span class="button__text">
        <ng-content></ng-content>
      </span>
    }
  </button>
}
